// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "js/vendors" + "." + "87f6206dbf2cdc0482e8" + ".css";
};